import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
  import { debounce } from 'lodash';
  import { usePagination, useTask } from '@/ui/concerns';
  import { Box, Loader } from '@/ui/components';
  import { Pagination } from '@/ui/components/Pagination';
  import SearchFilter from '@/ui/components/filters/horizontal/SearchFilter.vue';
  import { DropdownField } from '@/ui/components/form';
  import AiPhotoValidationList from '@/ui/pages/forms/FormsIndexPage/tabs/aiPhotoValidation/AiPhotoValidationList.vue';
  import AiPhotoValidationEmptyState
    from '@/ui/pages/forms/FormsIndexPage/tabs/aiPhotoValidation/AiPhotoValidationEmptyState.vue';
  import ConfidenceRangeFilter from '@/ui/pages/forms/FormsIndexPage/tabs/aiPhotoValidation/ConfidenceRangeFilter.vue';
  import { list } from '@/services/api/resources/aiPhotoValidation';
  import { parseConfidenceValue, useConfidenceRangeValidation } from '@/ui/pages/forms/FormsIndexPage/tabs/aiPhotoValidation/useConfidenceRangeValidation';
  import * as qs from '@/ui/queryState';
  import { AiPhotoValidationListResponse } from '@/entities/aiPhotoValidation';
  import { VALIDATION_RESULT } from '@/services/api/resources/aiPhotoValidation/query';
  import { t } from '@/ui/i18n/i18n';
  import {
    useAiPhotoValidationCheck,
  } from '@/ui/pages/forms/FormsIndexPage/tabs/aiPhotoValidation/useAiPhotoValidationCheck';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiPhotoValidationTab',
  setup(__props) {

  const { checkResult, taskReportCheck } = useAiPhotoValidationCheck();

  const search = qs.string('q', '');
  const validationResult = qs.nullableNumber('validationResult', null);
  const confidenceMinString = qs.string('confidenceMin', '');
  const confidenceMaxString = qs.string('confidenceMax', '');

  const records = ref<AiPhotoValidationListResponse>({
    data: [],
    meta: {
      total: 0,
      current_page: 1,
      last_page: 1,
    },
  });
  const initialLoading = ref(true);

  const {
    page,
    perPage,
    resetPagination,
  } = usePagination();

  const confidenceMin = computed(() => parseConfidenceValue(confidenceMinString.value));
  const confidenceMax = computed(() => parseConfidenceValue(confidenceMaxString.value));

  const { minError: confidenceMinError, maxError: confidenceMaxError, hasValidationErrors } = useConfidenceRangeValidation(
    confidenceMin,
    confidenceMax,
  );

  const getList = useTask(
    () => list({
      page: page.value,
      perPage: perPage.value,
      search: search.value || undefined,
      validationResult: validationResult.value !== null ? validationResult.value as VALIDATION_RESULT : undefined,
      confidenceMin: confidenceMin.value !== null ? confidenceMin.value : undefined,
      confidenceMax: confidenceMax.value !== null ? confidenceMax.value : undefined,
    }),
    listResponse => {
      records.value = listResponse as AiPhotoValidationListResponse;
    },
  );

  const debouncedGetList = debounce(() => {
    if (!hasValidationErrors.value) {
      getList.run();
    }
  }, 300);

  watch([
    page,
    perPage,
    validationResult,
    confidenceMin,
    confidenceMax,
  ], () => {
    if (!hasValidationErrors.value) {
      getList.run();
    }
  });

  watch(search, debouncedGetList);

  watch(() => getList.state.value.pending, newVal => {
    initialLoading.value = newVal;
  });

  const validationResultOptions = [
    { value: null, label: t('common.all') },
    { value: VALIDATION_RESULT.POSITIVE, label: t('ai-photo-validation.positive') },
    { value: VALIDATION_RESULT.NEGATIVE, label: t('ai-photo-validation.negative') },
  ];

  const handleSearchInput = (value: string) => {
    search.value = value;
    resetPagination();
  };

  const handleValidationResultInput = (value: number | null) => {
    validationResult.value = value;
    resetPagination();
  };

  const handleConfidenceMinInput = (value: string) => {
    confidenceMinString.value = value;
    resetPagination();
  };

  const handleConfidenceMaxInput = (value: string) => {
    confidenceMaxString.value = value;
    resetPagination();
  };

return { __sfc: true,checkResult, taskReportCheck, search, validationResult, confidenceMinString, confidenceMaxString, records, initialLoading, page, perPage, resetPagination, confidenceMin, confidenceMax, confidenceMinError, confidenceMaxError, hasValidationErrors, getList, debouncedGetList, validationResultOptions, handleSearchInput, handleValidationResultInput, handleConfidenceMinInput, handleConfidenceMaxInput, Box, Loader, Pagination, SearchFilter, DropdownField, AiPhotoValidationList, AiPhotoValidationEmptyState, ConfidenceRangeFilter }
}

})